export const SLA_CONSTANTS = {
  GET_SLAS_REQUEST: 'GET_SLAS_REQUEST',
  GET_SLAS_SUCCESS: 'GET_SLAS_SUCCESS',
  GET_SLAS_FAILURE: 'GET_SLAS_FAILURE',
}
